import { useMutation, useQueryClient } from "@tanstack/react-query";
import Swal from "sweetalert2";
import { showSuccessToast } from "../../utils/showToastAlert";

export function useDeleteDataService({ callApiWithWorker, t }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["deleteDataService"],

    mutationFn: async ({ id }) => {
      if (!id) throw new Error("Missing dataService id");

      try {
        const res = await callApiWithWorker(`/dataservices/${id}`, {
          method: "DELETE",
        });

        const status =
          res?.statusCode ??
          res?.data?.statusCode ??
          res?.status ??
          res?.data?.status;

        if (typeof res?.ok === "boolean" && !res.ok) {
          const e = new Error(`Delete failed (${status ?? "unknown"})`);
          e.statusCode = status;
          throw e;
        }

        if (status && status >= 400) {
          const e = new Error(`Delete failed (${status})`);
          e.statusCode = status;
          throw e;
        }

        return { ok: true };
      } catch (err) {
        const status = err?.statusCode ?? err?.response?.status;
        const e = new Error(
          err?.message || `Delete failed (${status ?? "unknown"})`,
        );
        e.statusCode = status;
        throw e;
      }
    },

    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["dataServices"] });
      showSuccessToast(t?.("common.deleteSuccessMessage") || "Deleted successfully", {
        title: t?.("common.deleteSuccessTitle") || "Deleted!",
      });
    },

    onError: async (error) => {
      if (error?.statusCode === 409) {
        await Swal.fire({
          icon: "warning",
          title: t?.("common.cannotDelete") || "No se pudo borrar",
          text:
            t?.("common.deleteConflict") ||
            "Este elemento está actualmente en uso, por favor, elimine los elementos asociados",
        });
        return;
      }
    },
  });
}
